/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CustomerBusinessKind = {
    Shipper: 'SHIPPER',
    FreightBroker: 'FREIGHT_BROKER',
    FreightForwarder: 'FREIGHT_FORWARDER',
    ThirdPartyLogistics: 'THIRD_PARTY_LOGISTICS',
    Carrier: 'CARRIER'
} as const;
export type CustomerBusinessKind = typeof CustomerBusinessKind[keyof typeof CustomerBusinessKind];

